export default __webpack_public_path__ + "static/media/NFT1.f1af98cf.png";